import React, {FC} from 'react';
import Modal from "./ui/Modal";
import {useAppDispatch} from "../hooks/redux";
import {deleteProduct, setDeleteProduct} from "../store/slices/gpsrProductsSlice";
import {useTranslation} from "react-i18next";
import {addNotification} from "../store/slices/notificationSlice";

interface GpsrDeleteProductModalProps {
    open: boolean;
    onClose: () => void;
    productId: string | null;
    productName: string;
}

const GpsrDeleteProductModal: FC<GpsrDeleteProductModalProps> = ({open, onClose, productId, productName}) => {
    const {t} = useTranslation();
    const dispatch = useAppDispatch();

    const deleteHandle = async (productId: string, productName: string) => {
        const response = await dispatch(deleteProduct(productId)).unwrap()

        if (response.status === "success") {
            dispatch(setDeleteProduct(productId));
            dispatch(
                addNotification({
                    type: "success",
                    title: "",
                    message: t('gpsr:delete_product_notification_success', {name: productName}),
                })
            );
        }

        onClose();
    }

    return (
        <Modal hideCloseButton={true} isCentered={true} isOpen={open} onClose={onClose} title={t('gpsr:delete_product_modal_title')}>
            <div className='gpsr-modal-body-wrapper'>
                <div className='gpsr-modal-body-text'>
                    <span>{t('gpsr:delete_product_modal_body_prefix')}</span>
                    {t('gpsr:delete_product_modal_body_text')}
                </div>

                <div className='gpsr-modal-body-buttons'>
                    <button onClick={onClose} className='modal-button cancel-delete'>
                        {t('cancelText')}
                    </button>

                    <button className='modal-button confirm-delete ml-24' onClick={() => deleteHandle(productId as string, productName)}>
                        {t('gpsr:delete_product_modal_delete_button_text')}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default GpsrDeleteProductModal;